import * as fendiProduct from '@qwentes/fendi/umd/product';

class HeavenLightMediaPriority {
  constructor() {
    this.PRIORITY = [
      HeavenLightMediaPriority.F4_ECOMMERCE,
      HeavenLightMediaPriority.F4_CAMPAIGN,
      HeavenLightMediaPriority.ECOMMERCE,
      HeavenLightMediaPriority.ENRICHMENT,
      HeavenLightMediaPriority.DATA_WAREHOUSE,
    ];
    this.MAP = {
      dwh: HeavenLightMediaPriority.DATA_WAREHOUSE,
      enrichment: HeavenLightMediaPriority.ENRICHMENT,
      ecommerce: HeavenLightMediaPriority.ECOMMERCE,
      f4Ecommerce: HeavenLightMediaPriority.F4_ECOMMERCE,
      f4Campaign: HeavenLightMediaPriority.F4_CAMPAIGN,
    };
  }

  getProviderName(name) {
    return this.MAP[name] || 'UNKNOWN';
  }
}

HeavenLightMediaPriority.F4_ECOMMERCE = 'f4Ecommerce';
HeavenLightMediaPriority.F4_CAMPAIGN = 'f4Campaign';
HeavenLightMediaPriority.DATA_WAREHOUSE = 'dataWarehouse';
HeavenLightMediaPriority.ENRICHMENT = 'enrichment';
HeavenLightMediaPriority.ECOMMERCE = 'ecommerce';

const mediaPriority = new HeavenLightMediaPriority();

export function createProduct(productXhr) {
  // TODO: rimuovere con nuova release di @qwentes/fendi
  const product = fendiProduct.createProduct(productXhr, {mediaPriority});
  return Object.assign(product, {
    lifespanDescription: productXhr.lifespanDescription,
    compositionDescription: productXhr.compositionDescription,
  });
}



// WEBPACK FOOTER //
// ./src/app/product/product.model.js